module.exports = "<a [routerLink]=\"[inputWhere]\"  >\n<i class=\"fa {{kind}} {{size}}\" aria-hidden=\"true\"></i>\n\t</a>\n\t\n"